"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[21111],{

/***/ 558118:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(225956);
var coreRenderer = __webpack_require__(327723);
var Container = __webpack_require__(739890);
var renderDynamicSlot = __webpack_require__(744175);
var EmptyProduct = __webpack_require__(867118);
var grid = __webpack_require__(793767);
var getStyles = __webpack_require__(523340);
var BlockHeader = __webpack_require__(177530);
var renderLink = __webpack_require__(62534);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CarouselSkuList = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    collectionSlug,
    viewMoreUrl,
    title,
    commonStyle,
    titleStyle,
    viewMoreStyle,
    maxWidth
  } = _a2, rest = __objRest(_a2, [
    "collectionSlug",
    "viewMoreUrl",
    "title",
    "commonStyle",
    "titleStyle",
    "viewMoreStyle",
    "maxWidth"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
      commonStyle: __spreadValues({ backgroundSize: "cover" }, restStyle)
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: `${title}HorizontalBlock`
    })), {
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(Label, {
              commonStyle: titleStyle,
              children: title
            }),
            renderViewAllLink()
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductListWrapper, {
          children: collectionSlug || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
            `product_carousel_${device}`,
            mappingDynamicSlots,
            ssrData,
            {
              collectionSlug
            }
          ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
        })
      ]
    }))
  }));
};
CarouselSkuList.displayName = "Omni_ProductSlider";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)(
  `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  color: #ffffff;
`
);
const Label = styled__default["default"].div(
  ({ commonStyle }) => `
    flex: 1;
    margin-right: 8px;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;

    ${getStyles.getStyle(commonStyle)}
  `
);
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${getStyles.getStyle(commonStyle)}
  `
);
const ProductListWrapper = styled__default["default"].div`
  padding: 1rem;
`;

exports.CarouselSkuList = CarouselSkuList;


/***/ }),

/***/ 557247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var MenuItems = __webpack_require__(662183);
var Container = __webpack_require__(739890);
var grid = __webpack_require__(793767);
var BlockHeader = __webpack_require__(177530);
var getStyles = __webpack_require__(523340);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAX_ITEMS_PER_VIEW = 6;
const CategoryMenu2Lines = (_a) => {
  var _b = _a, {
    isEditingMode,
    maxWidth,
    radius
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "maxWidth",
    "radius"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), { commonStyle, title, titleStyle, altStyle, items } = _a2, rest = __objRest(_a2, ["commonStyle", "title", "titleStyle", "altStyle", "items"]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const numberOfItems = items == null ? void 0 : items.length;
  const getSlidesPerView = () => {
    return numberOfItems <= MAX_ITEMS_PER_VIEW ? numberOfItems : MAX_ITEMS_PER_VIEW;
  };
  const getMenuItemsStyle = () => {
    return __spreadValues({
      slidesPerView: getSlidesPerView(),
      slidesPerGroup: 1,
      slidesPerColumn: 2,
      categoryMenuItems: items,
      imageSize: { height: 80, width: 80 },
      isEditingMode,
      altStyle,
      style: {
        padding: "24px 0 8px 0",
        margin: "0 16px"
      }
    }, numberOfItems > MAX_ITEMS_PER_VIEW * 2 ? { navigation: true, navigationStyle: 1 } : {});
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH_1600,
      padding,
      margin
    }
  }, rest), {
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH_1600,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: __spreadProps(__spreadValues({}, restStyle), { borderRadius: Number(radius) }),
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(MenuItems.MenuItems, __spreadValues({}, getMenuItemsStyle()))
      ]
    })
  }));
};
CategoryMenu2Lines.displayName = "Omni_BlockMenu2Lines";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 700;
  font-size: 20px;
  ${getStyles.getStyle(commonStyle)}; 
`
);

exports.CategoryMenu2Lines = CategoryMenu2Lines;


/***/ }),

/***/ 662183:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var Slider = __webpack_require__(699332);
var renderLink = __webpack_require__(62534);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const MenuItems = (_a) => {
  var _b = _a, {
    categoryMenuItems = [],
    imageSize,
    isEditingMode = false,
    altStyle
  } = _b, sliderProps = __objRest(_b, [
    "categoryMenuItems",
    "imageSize",
    "isEditingMode",
    "altStyle"
  ]);
  const { displayItems } = coreRenderer.useTimeVisibility(categoryMenuItems, isEditingMode);
  const renderMenuItem = (item) => {
    const { src, alt, googleImageParams, event } = item;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          commonStyle: {
            height: imageSize.height,
            width: imageSize.width,
            objectFit: "cover",
            marginLeft: "auto",
            marginRight: "auto"
          },
          src: src || defaultImage,
          alt,
          googleImageParams
        }),
        /* @__PURE__ */ jsxRuntime.jsx(StyledSubTitle, {
          commonStyle: altStyle,
          children: alt
        })
      ]
    });
    return renderLink.renderLink(event, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
    allowTouchMove: !isEditingMode
  }, sliderProps), {
    children: displayItems == null ? void 0 : displayItems.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "categoryList",
      contentName: item.alt,
      target: coreRenderer.getTargetOfTrackingFromEvent(item == null ? void 0 : item.event),
      index
    })), {
      children: renderMenuItem(item)
    }), index))
  }));
};
const StyledSubTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-align: center;
  word-wrap: break-word;
  padding-bottom: 16px;
  /* Mobile */
  @media only screen and (max-width: 460px) {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 4px;
  }

  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.MenuItems = MenuItems;


/***/ }),

/***/ 862261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var style = __webpack_require__(629909);
var image = __webpack_require__(698791);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MAX_CATEGORIES_PER_ROW = 3;
const BASE_CATEGORY_MENU_V2_DATA = {
  title: "Danh m\u1EE5c s\u1EA3n ph\u1EA9m",
  categories: {
    items: [...Array(MAX_CATEGORIES_PER_ROW * 2).keys()].map((item) => {
      return {
        alt: `menu_${item + 1}`,
        icon: image.generatePlaceholderImage({ width: 60, height: 60 }),
        subCategories: {
          items: [...Array(6).keys()].map((subItem) => {
            return { title: `category level 2_${item + 1}_${subItem + 1}` };
          })
        }
      };
    })
  }
};
const BASE_CATEGORY_STYLE = {
  titleStyle: {
    color: "#333333"
  },
  altStyle: {
    color: "#333333"
  },
  commonStyle: {
    background: "#ffffff",
    borderRadius: 8,
    padding: {
      left: 8,
      right: 8
    },
    margin: {
      bottom: 24
    }
  },
  categories: {
    titleStyle: {
      color: "#333333"
    },
    commonStyle: {
      background: "#f9f9f9"
    }
  }
};
const DEFAULT_CATEGORY_MENU_V2 = __spreadProps(__spreadValues(__spreadValues({}, BASE_CATEGORY_STYLE), BASE_CATEGORY_MENU_V2_DATA), {
  categories: __spreadValues(__spreadValues({}, BASE_CATEGORY_STYLE.categories), BASE_CATEGORY_MENU_V2_DATA.categories),
  commonStyle: __spreadValues(__spreadValues({}, style.MOBILE_COMMON_STYLE), BASE_CATEGORY_STYLE.commonStyle)
});

exports.DEFAULT_CATEGORY_MENU_V2 = DEFAULT_CATEGORY_MENU_V2;
exports.MAX_CATEGORIES_PER_ROW = MAX_CATEGORIES_PER_ROW;


/***/ }),

/***/ 399469:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var React = __webpack_require__(891987);
var constants = __webpack_require__(862261);
var render = __webpack_require__(294119);
var Container = __webpack_require__(739890);
var BlockHeader = __webpack_require__(177530);
var renderLink = __webpack_require__(62534);
var getStyles = __webpack_require__(523340);
var grid = __webpack_require__(793767);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DISPLAY_NAME = "Omni_BlockCategory";
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const CategoryMenuV2 = (_a) => {
  var _b = _a, {
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "isEditingMode"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    title,
    titleStyle,
    altStyle,
    categories,
    dataUniqId
  } = _a2, rest = __objRest(_a2, [
    "commonStyle",
    "title",
    "titleStyle",
    "altStyle",
    "categories",
    "dataUniqId"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const CATEGORY_MENU_V2_SS_KEY = `${DISPLAY_NAME}_${dataUniqId}`;
  const SSData = !!render.isServerless() ? sessionStorage.getItem(CATEGORY_MENU_V2_SS_KEY) : "";
  const parsedSSData = !!SSData ? JSON.parse(SSData) : {};
  const [activeCategoryIndex, setActiveCategoryIndex] = React.useState(parsedSSData.activeCategoryIndex);
  const numberOfColumns = Math.ceil(
    categories.items.length / constants.MAX_CATEGORIES_PER_ROW
  );
  const displayItems = [...Array(numberOfColumns).keys()].map((key) => {
    const startIndex = constants.MAX_CATEGORIES_PER_ROW * key;
    const endIndex = constants.MAX_CATEGORIES_PER_ROW * key + constants.MAX_CATEGORIES_PER_ROW;
    return categories.items.slice(startIndex, endIndex);
  });
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: grid.DEFAULT_MAX_WIDTH,
      padding,
      margin
    }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        displayItems.map((items, rowIndex) => {
          var _a3, _b3;
          return /* @__PURE__ */ jsxRuntime.jsxs("div", {
            style: { marginBottom: "8px" },
            children: [
              /* @__PURE__ */ jsxRuntime.jsx(CategoryWrapper, {
                children: items == null ? void 0 : items.map((categoryItem, colIndex) => {
                  var _a4;
                  const { icon, alt } = categoryItem;
                  return /* @__PURE__ */ jsxRuntime.jsxs("div", {
                    onClick: () => {
                      if ((activeCategoryIndex == null ? void 0 : activeCategoryIndex.row) !== rowIndex || (activeCategoryIndex == null ? void 0 : activeCategoryIndex.col) !== colIndex) {
                        setActiveCategoryIndex({
                          row: rowIndex,
                          col: colIndex
                        });
                        !!render.isServerless() && sessionStorage.setItem(
                          CATEGORY_MENU_V2_SS_KEY,
                          JSON.stringify({
                            activeCategoryIndex: {
                              row: rowIndex,
                              col: colIndex
                            }
                          })
                        );
                      } else {
                        setActiveCategoryIndex(void 0);
                        !!render.isServerless() && sessionStorage.setItem(
                          CATEGORY_MENU_V2_SS_KEY,
                          JSON.stringify({
                            activeCategoryIndex: void 0
                          })
                        );
                      }
                    },
                    children: [
                      /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
                        commonStyle: {
                          height: 60,
                          width: 60,
                          objectFit: "cover",
                          marginLeft: "auto",
                          marginRight: "auto"
                        },
                        src: icon || defaultImage,
                        alt: alt || "Category_Image"
                      }),
                      /* @__PURE__ */ jsxRuntime.jsx(StyledSubTitle, {
                        commonStyle: altStyle,
                        children: alt
                      }),
                      !!activeCategoryIndex && (activeCategoryIndex == null ? void 0 : activeCategoryIndex.row) === rowIndex && (activeCategoryIndex == null ? void 0 : activeCategoryIndex.col) === colIndex && /* @__PURE__ */ jsxRuntime.jsx(TopArrow, {
                        commonStyle: {
                          background: (_a4 = categories == null ? void 0 : categories.commonStyle) == null ? void 0 : _a4.background
                        }
                      })
                    ]
                  }, colIndex);
                })
              }),
              !!activeCategoryIndex && (activeCategoryIndex == null ? void 0 : activeCategoryIndex.row) === rowIndex && /* @__PURE__ */ jsxRuntime.jsx(Container.Container, {
                commonStyle: __spreadValues({
                  padding: { top: 8, right: 16, bottom: 8, left: 40 },
                  borderRadius: 6,
                  margin: { bottom: 8 }
                }, !!(categories == null ? void 0 : categories.commonStyle) ? categories == null ? void 0 : categories.commonStyle : {}),
                children: (_b3 = (_a3 = items == null ? void 0 : items[activeCategoryIndex.col]) == null ? void 0 : _a3.subCategories) == null ? void 0 : _b3.items.map(
                  (subCategoryItem, index) => {
                    const { title: title2, event } = subCategoryItem;
                    const content = /* @__PURE__ */ jsxRuntime.jsx(StyledSubCategoryTitle, __spreadProps(__spreadValues({
                      commonStyle: categories == null ? void 0 : categories.titleStyle
                    }, event), {
                      children: title2
                    }));
                    return /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({
                      style: index !== 0 ? { marginTop: 8 } : void 0
                    }, !isEditingMode && coreRenderer.getTrackingData({
                      isTrackContent: true,
                      regionName: "categoryMenuV2",
                      contentName: title2,
                      target: coreRenderer.getTargetOfTrackingFromEvent(event),
                      index
                    })), {
                      children: renderLink.renderLink(event, content, isEditingMode, index)
                    }), index);
                  }
                )
              })
            ]
          }, rowIndex);
        })
      ]
    })
  }));
};
CategoryMenuV2.displayName = DISPLAY_NAME;
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 10px;
  ${getStyles.getStyle(commonStyle)}; 
`
);
const StyledSubTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 14px;
  line-height: 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  text-align: center;
  word-wrap: break-word;
  margin-bottom: 4px;
  ${getStyles.getStyle(commonStyle)}
`
);
const CategoryWrapper = styled__default["default"].div`
  display: grid;
  grid-template-columns: repeat(${constants.MAX_CATEGORIES_PER_ROW}, 1fr);
  grid-column-gap: 12px;
`;
const StyledSubCategoryTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 14px;
  line-height: 22px;
  word-wrap: break-word;
  ${getStyles.getStyle(commonStyle)}
`
);
const TopArrow = styled__default["default"].div(
  ({ commonStyle }) => `
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid ${commonStyle.background || "#f9f9f9"};
  margin: 0 auto;
`
);

exports.CategoryMenuV2 = CategoryMenuV2;


/***/ }),

/***/ 743542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var MenuItems = __webpack_require__(60773);
var Container = __webpack_require__(739890);
var BlockHeader = __webpack_require__(177530);
var grid = __webpack_require__(793767);
var getStyles = __webpack_require__(523340);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAX_ITEMS_PER_VIEW = {
  DESKTOP: 10,
  MOBILE: 5
};
const CategoryMenu = (_a) => {
  var _b = _a, {
    isEditingMode,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "maxWidth"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), { commonStyle, title, titleStyle, altStyle, items } = _a2, rest = __objRest(_a2, ["commonStyle", "title", "titleStyle", "altStyle", "items"]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const isDesktop = device === "desktop";
  const numberOfItems = items == null ? void 0 : items.length;
  const getSlidesPerView = () => {
    if (isDesktop) {
      return numberOfItems <= MAX_ITEMS_PER_VIEW.DESKTOP ? numberOfItems : 9.5;
    }
    if (numberOfItems <= MAX_ITEMS_PER_VIEW.MOBILE)
      return numberOfItems;
    return numberOfItems <= MAX_ITEMS_PER_VIEW.DESKTOP ? 5 : 4.5;
  };
  const getMenuItemsStyle = () => {
    if (isDesktop) {
      return __spreadValues({
        slidesPerView: getSlidesPerView(),
        slidesPerGroup: 1,
        categoryMenuItems: items,
        imageSize: { height: 56, width: 56 },
        isEditingMode,
        altStyle,
        style: {
          padding: "24px 0",
          margin: "0 16px"
        }
      }, numberOfItems > MAX_ITEMS_PER_VIEW.DESKTOP ? { navigation: true, navigationStyle: 1 } : {});
    }
    return {
      slidesPerView: getSlidesPerView(),
      slidesPerGroup: 1,
      slidesPerColumn: (items == null ? void 0 : items.length) <= 5 ? 1 : 2,
      categoryMenuItems: items,
      imageSize: { height: 42, width: 42 },
      isEditingMode,
      altStyle,
      style: {
        padding: "12px 0 0 0",
        margin: "0 16px"
      }
    };
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH,
      padding,
      margin
    }
  }, rest), {
    maxWidth,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
            commonStyle: titleStyle,
            children: title
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(MenuItems.MenuItems, __spreadValues({}, getMenuItemsStyle()))
      ]
    })
  }));
};
CategoryMenu.displayName = "Omni_BlockMenu";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 700;
  font-size: 20px;
  ${getStyles.getStyle(commonStyle)}; 
`
);

exports.CategoryMenu = CategoryMenu;


/***/ }),

/***/ 60773:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var Slider = __webpack_require__(699332);
var renderLink = __webpack_require__(62534);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const MenuItems = (_a) => {
  var _b = _a, {
    categoryMenuItems = [],
    imageSize,
    isEditingMode = false,
    altStyle
  } = _b, sliderProps = __objRest(_b, [
    "categoryMenuItems",
    "imageSize",
    "isEditingMode",
    "altStyle"
  ]);
  const { device } = coreRenderer.useStore();
  const { displayItems } = coreRenderer.useTimeVisibility(categoryMenuItems, isEditingMode);
  const renderMenuItem = (item) => {
    const { src, alt, googleImageParams, event } = item;
    const content = /* @__PURE__ */ jsxRuntime.jsxs("div", {
      style: { paddingBottom: device === "desktop" ? "0px" : "16px" },
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          commonStyle: {
            height: imageSize.height,
            width: imageSize.width,
            objectFit: "cover",
            marginLeft: "auto",
            marginRight: "auto"
          },
          src: src || defaultImage,
          alt,
          googleImageParams
        }),
        /* @__PURE__ */ jsxRuntime.jsx(StyledSubTitle, {
          commonStyle: altStyle,
          children: alt
        })
      ]
    });
    return renderLink.renderLink(event, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Slider.Slider, __spreadProps(__spreadValues({
    allowTouchMove: !isEditingMode
  }, sliderProps), {
    children: displayItems == null ? void 0 : displayItems.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "categoryList",
      contentName: item.alt,
      target: coreRenderer.getTargetOfTrackingFromEvent(item == null ? void 0 : item.event),
      index
    })), {
      children: renderMenuItem(item)
    }), index))
  }));
};
const StyledSubTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-align: center;
  word-wrap: break-word;
  /* Mobile */
  @media only screen and (max-width: 460px) {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 4px;
  }
  margin-top: 8px;

  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.MenuItems = MenuItems;


/***/ })

}]);